import React from 'react'
import Truncate from 'react-truncate'

const DynamicLinkField = ({ url }) => (
  <a href={url} target="_blank">
    <Truncate size={2} ellipsis={<span>...</span>}>{url}</Truncate>
  </a>
)

export default DynamicLinkField



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkField.js